export class SysOrganization {
    name: string;
    handle: string;
    createdOn: string;
    deletePending: boolean;
    dsdDirectory: any;
    processing: boolean;
    serviceHandle: string;
    serviceName: string;
    storageExport: string;
    storageHandle: string;
    storageIpAddress: string;
    vsdDirectory: string;
    wrdDirectory: string;
    storageUsages: Array<any>;

    constructor(value?: Partial<SysOrganization>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
